/**
 * Centered confirmation modals (Family 2).
 *
 * Shared implementation lives in `@monorepo/shared-lib`. This file wraps it
 * so existing generate.TAX imports keep working and PWA mobile nav is applied.
 *
 * Use StyledPopconfirm for inline button-attached actions (Family 1).
 * Use UpgradeMessage for plan-gate / upsell prompts (Family 3).
 * See CONFIRMATION_DIALOGS.md for the full decision matrix.
 */
import {
  ConfirmModal as SharedConfirmModal,
} from '@monorepo/shared-lib';
import type { ConfirmModalProps } from '@monorepo/shared-lib';
import * as React from 'react';
import { usePwaMobileNavEnabled } from 'utils/usePwaMobileNavEnabled';
import { useOverlayBackHandler } from 'utils/useOverlayBackHandler';

export {
  ConfirmModalBody,
  ConfirmModalFooter,
  StyledConfirmModalCompact,
  StyledConfirmModalStandard,
  StyledUnsavedChangesModal,
} from '@monorepo/shared-lib';
export type {
  ConfirmModalAction,
  ConfirmModalActionVariant,
  ConfirmModalProps,
  ConfirmModalSize,
} from '@monorepo/shared-lib';

let confirmModalSeq = 0;

export const ConfirmModal: React.FC<ConfirmModalProps> = (props) => {
  const pwaMobileNav = usePwaMobileNavEnabled();
  const instanceId = React.useRef(`confirm-modal:${++confirmModalSeq}`);

  const handleBackClose = React.useCallback(() => {
    if (typeof props.onCancel === 'function') {
      props.onCancel(
        new MouseEvent('click') as unknown as React.MouseEvent<HTMLButtonElement>
      );
      return;
    }
    props.cancelAction?.onClick?.();
  }, [props.onCancel, props.cancelAction]);

  useOverlayBackHandler(
    Boolean(props.open),
    handleBackClose,
    instanceId.current,
    pwaMobileNav
  );

  return <SharedConfirmModal {...props} pwaMobileNav={pwaMobileNav} />;
};
